<script context="module" lang="ts">
  export interface ISpotPanel {
    columnsCount: number;
    items: ISpotItem[];
    title: string;
  }

  export interface ISpotItem {
    link: IULink;
    title: string;
    date: string;
    description: string;
    image: IUPicture;
  }
</script>

<script>
  import MobileSlider from "./mobile-slider/MobileSlider.svelte";
  import { sm } from "../../../core";
  import Item from "./Item.svelte";
  import type { IULink, IUPicture } from "../../../core/types";

  export let data: ISpotPanel;

  let itemsPerPage = window.innerWidth > sm ? 2 : 1;
</script>

<section class="spot-panel g-centered">
  <h2 class="title">{data.title}</h2>

  <div class="items items-mob">
    <MobileSlider items={data.items} {itemsPerPage} let:item>
      <div class="item-mob">
        <Item {item} />
      </div>
    </MobileSlider>
  </div>

  <div
    class="items items-desk"
    style="grid-template-columns: repeat({data.columnsCount}, 1fr);"
  >
    {#each data.items as item}
      <Item {item} />
    {/each}
  </div>
</section>

<style lang="scss">
  .spot-panel {
    @include md-down {
      padding-top: 20px;
      padding-bottom: 1px;
      margin-bottom: 30px;
      background-color: #ebebeb;
    }
  }

  .title {
    @include h2;
    margin-bottom: 20px;

    @include md {
      margin-bottom: 30px;
    }
  }

  .items {
    display: grid;
    margin: 0 0 50px;
    column-gap: 30px;
    row-gap: 20px;
  }

  .items-mob {
    margin-bottom: 25px;
    @include md-hide;
  }

  .items-desk {
    @include md-show;
  }

  .item-mob {
    margin-bottom: 10px;
    flex: 1 0 100%;
    max-width: 100%;

    @include sm {
      flex: 1 0 50%;
      max-width: 50%;
    }
  }
</style>
